"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentFileStatus;
(function (DocumentFileStatus) {
    DocumentFileStatus["INFECTED"] = "infected";
    DocumentFileStatus["CLEAN"] = "clean";
    DocumentFileStatus["NO"] = "no";
})(DocumentFileStatus = exports.DocumentFileStatus || (exports.DocumentFileStatus = {}));
var DocumentFileActions;
(function (DocumentFileActions) {
    DocumentFileActions["DELETE"] = "delete";
    DocumentFileActions["TAG"] = "tag";
    DocumentFileActions["NO"] = "no";
    DocumentFileActions["CREATE"] = "create";
})(DocumentFileActions = exports.DocumentFileActions || (exports.DocumentFileActions = {}));
exports.DocumentUnScannedRootFolder = 'unscannedfiles/Document';
exports.DocumentScannedRootFolder = 'XfilesPro Root/Document';
// Case Folder in S3
exports.CaseUnScannedRootFolder = 'unscannedfiles/Case';
exports.CaseScannedRootFolder = 'XfilesPro Root/Case';
//# sourceMappingURL=index.js.map